/**
 * ScrollToHash — scrolt na route-wissel naar de in `location.hash` opgegeven anchor.
 * Retried tot het element in de DOM staat (max ~1.2s) zodat lazy-rendered sections ook werken.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    let attempts = 0;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        // Offset voor sticky header (~80px)
        const top = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
        return;
      }
      if (attempts++ < 12) setTimeout(tryScroll, 100);
    };
    // Wacht 1 frame zodat de nieuwe route gerendered is
    requestAnimationFrame(tryScroll);
  }, [hash, pathname]);

  return null;
}
